import { serifStyles } from "@pathwright/blocks/src/ui/typography"
import { Content } from "@pathwright/ui/src/components/content/Content"
import renderMathInElement from "@pathwright/ui/src/components/text/katex-auto-render"
import React from "react"
import styled from "styled-components"
import { interpolateVariables } from "../utils/variables"

export const SubTextWrapper = styled.div`
  margin-top: 10px;
  ul {
    margin: 0px;
  }

  ul li {
    list-style-type: none;
  }
  ol li:not(.ql-direction-rtl),
  ul li:not(.ql-direction-rtl) {
    padding-left: 0;
  }
  // Hacky - accounts for padding on ol/ul element that's present only in Preview mode.
  ol [class^="ql-indent"],
  ul [class^="ql-indent"] {
    margin-left: -1.5em;
  }
  ul li:before {
    content: "\\2022";
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right;
    display: inline-block;
    white-space: nowrap;
    width: 1.2em;
  }
  p,
  p span,
  li {
    color: #2a2e33;
    font-weight: 400;
    line-height: 1.3em;
    ${serifStyles({ size: 20 })}
    margin: 0px;
  }
  span {
    ${serifStyles({ size: 16 })}
    font-weight: 500;
    line-height: 1.2em;
    color: #666;
  }

  .katex,
  .katex span {
    font-size: 100%;
    white-space: pre-wrap !important;
  }
`

const SubText = (props) => {
  const { html, text, templateContext, style, mode } = props

  const subtextRef = React.createRef()

  React.useEffect(() => {
    if (!subtextRef.current) return

    startKatex()
  }, [subtextRef.current])

  const startKatex = () => {
    // const el = ReactDOM.findDOMNode(this)
    const el = subtextRef.current
    renderMathInElement(el, false)
    // responsifyKatex(el)
  }

  let content = html ? html : text

  if (templateContext) {
    try {
      content = interpolateVariables(content, templateContext)
    } catch (error) {
      console.error("Error parsing template: ", error.toString())
    }
  }

  if (html) {
    return (
      <Content.Text>
        <SubTextWrapper
          ref={subtextRef}
          className={`SubText SubText--${(mode || "view").toLowerCase()}`}
          dangerouslySetInnerHTML={{ __html: content }}
          style={style}
        />
      </Content.Text>
    )
  }

  return <div className="SubText">{content}</div>
}

export default SubText
